import { ApolloError } from "@apollo/client";

import Sentry from "../../sentry";
import { useAuthContext } from "../../context/auth/useAuthContext";
import {
  EnergyServiceState,
  useEnergyServicesQuery,
} from "../../generated/customer/schema.graphql";
import { isBrowserSupported } from "../../components/UnsupportedBrowser";

export const useHasLiveEnergyService = (): boolean => {
  const { instigator } = useAuthContext();

  const customerAccountID = instigator.accountID;
  const customerAccountNo = instigator.accountNumber;

  const { data } = useEnergyServicesQuery({
    skip: !customerAccountID.length,
    onError: (e: ApolloError) => {
      if (isBrowserSupported()) {
        Sentry.getCurrentScope()
          .setTransactionName("useEnergyServicesQuery")
          .setTag("accountID", customerAccountID)
          .setTag("accountNumber", customerAccountNo)
          .captureException(e);
      }
    },
  });

  return (
    data?.account?.energy?.services.some(
      (service) => service.serviceState === EnergyServiceState.Started,
    ) ?? false
  );
};
